import React, { useState, useContext } from "react";
import { style_templates } from "../config_variables/styles";
import { variables } from "../config_variables/variables";
import { ActivityIndicator , View, Text, Button, StatusBar } from "react-native";
import { DataContext } from "../store/data-context";
import Icon2 from "react-native-vector-icons/FontAwesome";
import convertNumberToCommaSeparated from "../utils/convertNumberToCommaSeparated";
import convertNumberToCurrency  from "../utils/convertNumberToCurrency";

function screen1OverallSummary(props) {
  console.log("inside screen1OverallSummary");
  const [Screen1FetchComplete, setScreen1FetchComplete] = useState(false);
  const dataCtx = useContext(DataContext);
  
  React.useEffect(() => {
    console.log("inside useEffect in Screen1");
    console.log("Screen1FetchComplete : " + Screen1FetchComplete);
    if (Screen1FetchComplete) {
      console.log(
        " dataCtx.btrData inside useEffect:" + JSON.stringify(dataCtx.btrData)
      );
      dataCtx.changeFilterHandler("tranche");
    } else {
      checkContextAccess();
    }
  }, [dataCtx.btrData, dataCtx.resetFlag]);

  function checkContextAccess() {
    console.log("inside checkContextAccess");
    setScreen1FetchComplete(true);
    dataCtx.checkContext();
    dataCtx.getBtrData();
  }

  function swipetonextscreen() {
    console.log("inside swipetonextscreen");
    props.navigation.navigate("screen2OverallSummary", {
      //       screendataarray: dataCtx.screenDataArray,
    });
  }

  console.log("dataCtx.screenDataArray: " + JSON.stringify(dataCtx.screenDataArray))
  console.log('dataCtx.cardListData :  ' + JSON.stringify(dataCtx.cardListData))

        if(dataCtx.screenDataArray.length ==0) {
            dataCtx.screenDataArray = [...variables.null_screen_data]
      }

      return (
            <View  style={style_templates.app_container}>
                  <View style={style_templates.app_body_container}>
                        
                        <StatusBar animated={true} backgroundColor="#61dafb" />



                        {dataCtx.screenDataArray.length > 0 && (
                              <>
                                   <View style={style_templates.app_sub_container_header}>
                                          { dataCtx.dataFetchComplete && (
                                                <View style={style_templates.screen1_header}>
                                                      <Text style={style_templates.screen1_header_text}>BTR Summary</Text>
                                                </View>
                                          )}
                                          {!dataCtx.dataFetchComplete && (
                                                // <View  style={style_templates.screen1_loader_box}>
                                                <View  style={style_templates.loading_state_container}>
                                                      <Text>Loading...</Text>
                                                      <ActivityIndicator size="large" />
                                                </View>
                                          )}    

                                          {/* <View style={style_templates.next_screen_chevron}>
                                                <Pressable onPress={swipetonextscreen}>{">"}
                                                </Pressable>
                                          </View> */}

                                          {/* <View style={style_templates.screen1_container}> */}

                                          { dataCtx.dataFetchComplete && (
                                                <>
                                                {variables.screen1_metrics.map((m) => (
                                                      <View key={m.key} style={style_templates.screen1_container_box}>
                                                            <View style={style_templates.screen1_container_box_icon}>
                                                                  <View style = {[style_templates.screen_circle_icon, {backgroundColor: m.color}]}>
                                                                  {/* <View style = {[style_templates.screen_circle_icon]}> */}
                                                                        {/* <Icon2 name="check-square-o" size={20} color="white" /> */}
                                                                        <Icon2 name={m.icon} size={20} color="white" />
                                                                              {/* <MaterialIcons name="more-vert" size={23} color={colors.secondary} />                                                                         */}
                                                                  </View>
                                                            </View>
                                                            <View style={style_templates.screen1_container_box_count_and_text}>
                                                                  <View style={style_templates.screen1_container_box_count}>
                                                                        {dataCtx.screenDataArray.length > 0 && (
                                                                              <Text style={style_templates.dashboard_text_value}>
                                                                              {dataCtx.screenDataArray.find((s) => s.fieldapiname === m.apiname).value}
                                                                              </Text>
                                                                        )}
                                                                  </View>
                                                                  <View style={style_templates.screen1_container_box_text}>
                                                                        {/* <Text style={style_templates.dashboard_text_label}> */}
                                                                        <Text style={style_templates.screen1_desriptive_text}>
                                                                              {m.labelname}
                                                                        </Text>
                                                                  </View>                                                                  
                                                            </View>
                                                      </View>
                                                ))}
                                                </>
                                          )}
                                          {/* </View> */}
                                    </View>
                                    <View style={style_templates.screen1_summary_container}>
                                          <View style={style_templates.screen1_summary_container_box}>
                                                {/* {!dataCtx.dataFetchComplete && (
                                                      <>
                                                            <Text>Loading...</Text>
                                                            <ActivityIndicator size="small" />
                                                      </>
                                                )} */}
                                                {dataCtx.dataFetchComplete && (
                                                      <>
                                                            <View style={style_templates.screen1_summary_container_sub_box_left}>
                                                            </View>
                                                            <View style={[style_templates.screen1_summary_container_sub_box_right, {borderLeftColor:"blue",borderLeftWidth:3}]}>
                                                                  <Text style={style_templates.screen1_summary_container_label}>Total Value</Text>
                                                                  <Text style={style_templates.screen1_summary_container_text}>{convertNumberToCurrency(((dataCtx.screenDataArray.find((s) => s.fieldapiname === 'totalvalue').value) / 1000000).toFixed(0))} Million</Text>
                                                            </View>
                                                      </>
                                                )}
                                          </View>

                                          <View style={style_templates.screen1_summary_container_box}>
                                                {/* {!dataCtx.dataFetchComplete && (
                                                      <>
                                                            <Text>Loading...</Text>
                                                            <ActivityIndicator size="small" />
                                                      </>
                                                )} */}
                                                {dataCtx.dataFetchComplete && (
                                                      <>
                                                            <View style={style_templates.screen1_summary_container_sub_box_left}>                                                      
                                                            </View>
                                                            <View style={[style_templates.screen1_summary_container_sub_box_right, {borderLeftColor:"orange",borderLeftWidth:3}]}>
                                                                  <Text style={style_templates.screen1_summary_container_label}>Total Size</Text>
                                                                  <Text style={style_templates.screen1_summary_container_text}>{convertNumberToCommaSeparated((dataCtx.screenDataArray.find((s) => s.fieldapiname === 'size').value / 1000) .toFixed(0))}  K sq m </Text>
                                                            </View>
                                                      </>
                                                )}
                                          </View>
                                    </View>

                                    <View style={style_templates.screen1_footer}>
                                          <Button onPress={swipetonextscreen} title="NEXT SCREEN" />      
                                    </View>

                              </>
                        )}
                        {/* <View style={style_templates.app_sub_container}>
                        </View> */}
                  </View>
            </View >
      );
}

export default screen1OverallSummary;
